import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  Button,
  Checkbox,
  ActionSheet,
  Toast,
  WhiteSpace,
  Pagination,
  WingBlank
} from "antd-mobile";
import "./groupList.scss";
import axios from "../../../service/axios";
import GroupSearch from "../../../components/search/search";
const CheckboxItem = Checkbox.CheckboxItem;
const Item = List.Item;
const more_icon = require("../../../assets/images/icon/more_icon.png");
const drawerContainer = {
  position: "fixed",
  width: "100%",
  top: "45px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s"
};
export class GroupList extends Component {
  state = {
    showCheck: false,
    groupDatas: [],
    selectNum: 0,
    selectGids: [],
    pageTotalNum: 0,
    pageNo: 1,
    drawerSearch: document.body.clientWidth,
    searchKey: {},
    paramsSearchMy: ""
  };
  onChange = (e, i) => {
    console.log(e, i);
    if (e.target.checked) {
      this.setState({
        selectNum: this.state.selectNum + 1,
        selectGids: [...this.state.selectGids, i.gid]
      });
    } else {
      let selectGids = this.state.selectGids;
      selectGids.splice(selectGids.indexOf(i.gid), 1);
      this.setState({
        selectGids: selectGids,
        selectNum: this.state.selectNum - 1
      });
    }
    console.log(this.state.selectGids);
  };
  componentWillMount() {
    this.getGroupList();
    this.setState({
      paramsSearchMy: this.props.match.params.searchMy ? "/" + this.props.match.params.searchMy : "",
    });
  }
  deleteBtn() {
    if (this.state.selectNum < 1) {
      Toast.info("请选择要删除的群组", 1);
      return;
    }
    const BUTTONS = ["确定", "取消"];
    ActionSheet.showActionSheetWithOptions(
      {
        options: BUTTONS,
        message: "是否删除选中的群组？",
        maskClosable: true,
        "data-seed": "logId"
      },
      async buttonIndex => {
        console.log(buttonIndex);
        if (!buttonIndex) {
          console.log(this.state.selectGids);
          this.deleteGroups();
        }
      }
    );
  }
  deleteGroups() {
    axios
      .get("/api/oa/group/delete", {
        params: {
          gids: this.state.selectGids.join(",")
        }
      })
      .then(res => {
        if (res && res.status == 1000) {
          Toast.success("操作成功");
          this.getGroupList(1);
        }
      });
  }
  getGroupList(e) {
    axios
      .get("/api/oa/group/list", {
        params: {
          pageNo: e,
          pageSize: 10,
          searchMy: this.props.match.params.searchMy,
          ...this.state.searchKey
        }
      })
      .then(res => {
        if (res && res.status == 1000 && res.data) {
          this.setState({
            groupDatas: res.data.list.map(item => {
              item.checked = false;
              return item;
            }),
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.count / 10)
          });
        }
      });
  }
  onPageChange(e) {
    console.log(e);
    this.getGroupList(e);
    this.setState({
      selectNum: 0,
      selectGids: []
    });
  }
  onSearchList = e => {
    console.log(e);
    this.setState({
      searchKey: {
        ...e
      },
      drawerSearch: document.body.clientWidth
    });
    setTimeout(() => {
      this.getGroupList(1);
    }, 0);
  };
  render() {
    const { drawerSearch } = this.state;
    const data = [];
    for (let i = 0; i < 100; i++) {
      data.push({
        value: i,
        label: "zhaoyu" + i
      });
    }

    const userMsg =
      sessionStorage.getItem("loginMsg") &&
      JSON.parse(sessionStorage.getItem("loginMsg")).user;
    const { groupDatas, selectNum, pageTotalNum, pageNo } = this.state;
    return (
      <div className="groupList">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
            rightContent={[
              userMsg.userType == 1 ? (
                ""
              ) : this.state.showCheck ? (
                <Icon
                  onClick={() => {
                    this.setState({
                      showCheck: false
                    });
                  }}
                  key="1"
                  type="check"
                />
              ) : (
                <div key="3">
                  <span
                    type="search"
                    onClick={ () => {
                      this.setState({
                        drawerSearch: 0
                      });
                    }}
                    style={ {fontSize:'12px'} }
                  >查找</span> &ensp; &ensp;
                  <span
                    key= '0'
                    onClick= { () => {
                      this.setState({
                        showCheck: true,
                        selectNum: 0,
                      })
                    }}
                    style={ {fontSize:'12px'} }
                  >选项</span>
                </div>
              )
            ]}
          >
            {this.props.match.params.searchMy == 1? "我的群组":"群组列表"}
          </NavBar>
        </div>

        <div className="sub-container">
          <List>
            {groupDatas.map((i, index) => {
              return (
                <div key={index}>
                  {this.state.showCheck ? (
                    <CheckboxItem
                      key={index}
                      onChange={e => this.onChange(e, i)}
                    >
                      {i.name}
                    </CheckboxItem>
                  ) : (
                    <Item
                      key={index}
                      arrow="horizontal"
                      onClick={() =>
                        // this.props.history.push(
                        //   `/groupuserlist/${i.gid}/${i.name}`
                        // )
                        this.props.history.push(`/addgroup/edit/${i.gid}` + this.state.paramsSearchMy)
                      }
                    >
                      {i.name}
                    </Item>
                  )}
                </div>
              );
            })}
          </List>
          <WhiteSpace />
          <WingBlank>
            {pageTotalNum > 0 ? (
              <Pagination
                total={pageTotalNum}
                current={pageNo}
                locale={{
                  prevText: "上一页",
                  nextText: "下一页"
                }}
                onChange={e => this.onPageChange(e)}
              />
            ) : (
              ""
            )}
          </WingBlank>

          {this.state.showCheck ? (
            <div className="footer">
              <span>
                已选择：
                {selectNum}
                个群组
              </span>
              <Button
                type="warning"
                inline
                size="small"
                onClick={() => this.deleteBtn()}
              >
                删除
              </Button>
            </div>
          ) : (
            ""
          )}
          <div className="" style={{ ...drawerContainer, left: drawerSearch }}>
            <GroupSearch
              closeSearch={() =>
                this.setState({
                  drawerSearch: document.body.clientWidth
                })
              }
              onSearchList={this.onSearchList}
              type='group'
            />
          </div>
        </div>
      </div>
    );
  }
}

export default GroupList;
